
/**
 * @nullable
 */
export type MarkNotificationAsDelivered200Data = {[key: string]: unknown} | null;
